const ROWS = [
  { job: "#2231 · Ballito", reason: "parts on order", status: "ETA Friday", atRisk: true },
  { job: "#2247 · Thursday", reason: "2 techs short", status: "roster gap", atRisk: true },
  { job: "38 other jobs", reason: "-", status: "on track", atRisk: false },
];

/**
 * The hero visual: Lara answering an operational question from live data, with
 * its sources cited and the workflow it triggered.
 *
 * Illustrative sample data, not a real customer's - the job numbers and branch
 * are invented for the example, which is why nothing here is presented as a
 * metric or a claim.
 */
export function AnswerCard() {
  return (
    <div
      className="overflow-hidden rounded-2xl bg-brand-navy text-slate-300 shadow-2xl"
      role="img"
      aria-label="Lara identifying three at-risk jobs from live operational data, and triggering a purchase order and a message to the scheduler"
    >
      <div className="flex items-center gap-3 border-b border-white/10 px-5 py-3">
        <span className="grid h-7 w-7 place-items-center rounded-full bg-brand-turquoise text-sm font-bold text-brand-navy">
          L
        </span>
        <span className="font-semibold text-white">Lara</span>
        <span className="ml-auto font-mono text-[10px] uppercase tracking-widest text-brand-turquoise">
          live · cited
        </span>
      </div>

      <p className="border-b border-dashed border-white/10 px-5 py-4 font-mono text-sm text-white">
        <span className="font-bold text-brand-turquoise">?</span> Which jobs due
        this week are at risk?
      </p>

      <div className="space-y-3 px-5 py-4">
        <p className="text-sm">Three of 41 scheduled jobs are at risk:</p>
        <table className="w-full font-mono text-xs">
          <tbody>
            {ROWS.map((row) => (
              <tr key={row.job} className="border-t border-dashed border-white/10">
                <td className="py-2 pr-2">{row.job}</td>
                <td className="py-2 pr-2 text-slate-400">{row.reason}</td>
                <td
                  className={
                    row.atRisk
                      ? "py-2 text-right font-semibold text-amber-300"
                      : "py-2 text-right font-semibold text-emerald-300"
                  }
                >
                  {row.status}
                  {row.atRisk ? "" : " ✓"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <p className="font-mono text-[11px] text-slate-500">
          Sources: job cards · stock system · staff roster · synced 06:00
        </p>
      </div>

      <p className="border-t border-white/10 bg-emerald-400/10 px-5 py-3 font-mono text-xs text-emerald-300">
        → workflow: PO drafted for parts · message to the scheduler
      </p>
    </div>
  );
}
